import aboutData from "./about.json";
import educationData from "./education.json";
import workExperienceData from "./work_experience.json";
import projectExperienceData from "./project_experience.json";

function normalizeTechnologies(raw) {
  if (!raw) return "";
  let value = String(raw).trim();
  if (value.startsWith('"') && value.endsWith('"')) {
    value = value.slice(1, -1);
  }
  return value;
}

function toEducation(row) {
  return {
    id: row.id,
    school: row.school,
    degree: row.degree,
    fieldOfStudy: row.field_of_study,
    startDate: row.start_date,
    endDate: row.end_date,
    description: row.description,
    imageUrl: row.image_url,
    gpa: row.gpa,
  };
}

function toWorkExperience(row) {
  return {
    id: row.id,
    company: row.company,
    position: row.position,
    startDate: row.start_date,
    endDate: row.end_date,
    description: row.description,
    imageUrl: row.image_url,
    isCurrent: Boolean(row.is_current),
  };
}

function toProject(row) {
  return {
    id: row.id,
    title: row.title,
    description: row.description,
    technologies: normalizeTechnologies(row.technologies),
    startDate: row.start_date,
    endDate: row.end_date,
    imageUrl: row.image_url,
    projectUrl: row.project_url,
    link: row.link,
  };
}

function sortByStartDateDesc(items) {
  return [...items].sort(
    (a, b) => new Date(b.startDate) - new Date(a.startDate)
  );
}

function sortWorkExperiences(items) {
  return [...items].sort((a, b) => {
    if (a.isCurrent !== b.isCurrent) {
      return b.isCurrent - a.isCurrent;
    }
    return new Date(b.startDate) - new Date(a.startDate);
  });
}

export const about = aboutData[0] ?? null;
export const educations = educationData.map(toEducation);
export const workExperiences = sortWorkExperiences(
  workExperienceData.map(toWorkExperience)
);
export const projects = sortByStartDateDesc(
  projectExperienceData.map(toProject)
);
